import { Div, Link, Span } from "@tblabs/truffle";
import { Svg } from "../Components/Utils/Svg";
import { Heading } from "../../Components/Heading";


export class ContactInfo extends Div
{
    constructor(svgIcon: string, title: string, text: string)
    {
        super();

        this.Append(
            new Div("contact-info__item").Append(
                new Div("contact-info__icon").Append(new Svg(svgIcon)),
                new Div("contact-info__content").Append(
                    new Heading(title, 3),
                    new Link(text).OpenInNewCard(),
                )
            )
        );
    }
}
